import React, { useState } from 'react';
import {
  Box,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Chip,
  Paper,
  Typography,
  Grid,
  IconButton
} from '@mui/material';
import {
  Palette as PaletteIcon,
  Check as CheckIcon
} from '@mui/icons-material';
import { useTheme } from '../hooks/useTheme';

const ThemeSwitcher = ({ variant = 'dropdown' }) => {
  const { currentPalette, setPalette, availablePalettes, isActivePalette } = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlePaletteSelect = (paletteId) => {
    setPalette(paletteId);
    handleClose();
  };

  if (variant === 'inline') {
    return (
      <Box>
        <Typography variant="h6" gutterBottom>
          Choose a Theme
        </Typography>
        <Grid container spacing={2}>
          {availablePalettes.map((palette) => (
            <Grid item xs={6} sm={4} md={3} key={palette.id}>
              <Paper
                sx={{
                  p: 2,
                  cursor: 'pointer',
                  border: isActivePalette(palette.id) ? 2 : 1,
                  borderColor: isActivePalette(palette.id) ? 'primary.main' : 'divider',
                  '&:hover': { borderColor: 'primary.main' }
                }}
                onClick={() => handlePaletteSelect(palette.id)}
              >
                <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: 1,
                      bgcolor: palette.colors.primary
                    }}
                  />
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: 1,
                      bgcolor: palette.colors.secondary
                    }}
                  />
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: 1,
                      bgcolor: palette.colors.accent
                    }}
                  />
                </Box>
                <Typography variant="body2" fontWeight="medium">
                  {palette.name}
                </Typography>
                {isActivePalette(palette.id) && (
                  <Chip label="Active" size="small" color="primary" sx={{ mt: 0.5 }} />
                )}
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  }

  return (
    <>
      <IconButton
        onClick={handleClick}
        aria-label="Change color theme"
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        sx={{
          color: 'inherit',
          '&:hover': {
            bgcolor: 'action.hover'
          }
        }}
      >
        <PaletteIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: { minWidth: 250 }
        }}
      >
        {availablePalettes.map((palette) => (
          <MenuItem
            key={palette.id}
            onClick={() => handlePaletteSelect(palette.id)}
            selected={isActivePalette(palette.id)}
          >
            <ListItemIcon>
              <Box
                sx={{
                  width: 24,
                  height: 24,
                  borderRadius: 0.5,
                  bgcolor: palette.colors.primary,
                  border: '1px solid',
                  borderColor: 'divider'
                }}
              />
            </ListItemIcon>
            <ListItemText
              primary={palette.name}
              secondary={palette.description}
            />
            {isActivePalette(palette.id) && (
              <CheckIcon color="primary" sx={{ ml: 1 }} />
            )}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ThemeSwitcher;






